import { createContext } from "react"

export interface DayMetricContextValue {
  openDayMetricModal: () => void;
}

type ContextType = DayMetricContextValue | null

export const DayMetricContext = createContext<ContextType>(null)
